<div class="gs-wrapper">
  <div class="gs-input-box">
    <i class="fas fa-search gs-icon"></i>
    <input
      type="text"
      id="global-search-search-input"
      class="gs-input"
      [value]="searchText()"
      (input)="onSearchInput($any($event.target).value)"
      (focus)="onFocus()"
      placeholder="Search pages, columns..."
      autocomplete="off"
      aria-label="Global search"
    />
  </div>

  @if (open() && results().length) {
    <div class="gs-panel">
      @for (result of results(); track result.path) {
        <button type="button" [id]="'global-search-result-' + $index + '-btn'" class="gs-row" (click)="select(result)">
          <span class="gs-row-name" [innerHTML]="result.name | ghlHighlight: term()"></span>
          <span class="gs-row-path">
            <i class="fas fa-location-arrow"></i> {{ result.path }}
          </span>
          @if (result.matchedKeyword) {
            <span class="gs-row-sub">
              matched: <span [innerHTML]="result.matchedKeyword | ghlHighlight: term()"></span>
            </span>
          }
        </button>
      }
    </div>
  } @else if (open() && term()) {
    <div class="gs-panel">
      <div class="gs-empty" id="global-search-empty-title">No results for "{{ term() }}"</div>
    </div>
  }
</div>
